document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.getElementById('SliderWrapper');
  const container = document.getElementById('CustomSlider');
  const slides = document.querySelectorAll('.custom-slide');
  const dots = document.querySelectorAll('.dot');
  let currentIndex = 0;
  let autoSlideInterval;

  function updateSlider() {
    const width = container.clientWidth;
    wrapper.style.transform = `translateX(-${currentIndex * width}px)`;
    dots.forEach((dot, i) => { dot.classList.toggle('active', i === currentIndex); });
  }

  window.nextSlide = function() { currentIndex = (currentIndex + 1) % slides.length; updateSlider(); }
  window.prevSlide = function() { currentIndex = (currentIndex - 1 + slides.length) % slides.length; updateSlider(); }
  window.currentSlide = function(index) { currentIndex = index; updateSlider(); }

  function startAuto() { autoSlideInterval = setInterval(nextSlide, 5000); }
  container.addEventListener('mouseenter', () => clearInterval(autoSlideInterval));
  container.addEventListener('mouseleave', startAuto);
  window.addEventListener('resize', updateSlider);
  updateSlider();
  startAuto();
});
